/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
import React, { useState, useEffect, useCallback } from 'react';

import PropTypes from 'prop-types';

import { useForm } from 'react-hook-form';

import { toast } from 'react-toastify';

import Swal from 'sweetalert2';

import moment from 'moment';

import 'moment/locale/pt-br';

import locale from 'antd/es/date-picker/locale/pt_BR';

import { Switch, DatePicker } from 'antd';

import { IoMdArrowBack } from 'react-icons/io';

import history from '~/services/history';

import { store } from '~/store';

import { Breadcumbs } from '~/components/Breadcumbs';

import CancelIcon from '~/assets/icons/cancel-icon-indicador.png';

import {
  PageTitle,
  BoxContent,
  Container,
  Content,
  FormContainer,
  BoxForm,
  TitleSection,
  Row,
  Col,
  ButtonBox,
  SwitchButton,
} from './style';

import api from '~/services/api';

import GreenButton from '~/components/Button';
import { nomeIndicadores } from './nomeIndicadores';

moment.locale('pt-br');

const SelecaoDasLinhasDeCuidado = ({ location }) => {
  const { token, roles } = store.getState().auth;
  const ROLE_ADMIN = roles.includes('ROLE_ADMIN');
  if (!ROLE_ADMIN) {
    history.push('/');
  }

  const { MonthPicker } = DatePicker;

  const { handleSubmit } = useForm();

  const [active, setActive] = useState(true);

  //  Indicadores Painel Geral
  const [indicPainelGeralAtivo, setIndicPainelGeralAtivo] = useState(true);
  const [indicPainelGeralInicio, setIndicPainelGeralInicio] = useState(null);
  const [indicPainelGeralTermino, setIndicPainelGeralTermino] = useState(null);

  // Acidente Vascular Cerebral
  const [indicAvcAtivo, setIndicAvcAtivo] = useState(true);
  const [indicAvcInicio, setIndicAvcInicio] = useState(null);
  const [indicAvcTermino, setIndicAvcTermino] = useState(null);

  // Artropatia de Quadril
  const [artroDeQuadrilAtivo, setArtroDeQuadrilAtivo] = useState(true);
  const [artroDeQuadrilInicio, setArtroDeQuadrilInicio] = useState(null);
  const [artroDeQuadrilTermino, setArtroDeQuadrilTermino] = useState(null);

  // Câncer de Mama
  const [cancerDeMamaAtivo, setCancerDeMamaAtivo] = useState(true);
  const [cancerDeMamaInicio, setCancerDeMamaInicio] = useState(null);
  const [cancerDeMamaTermino, setCancerDeMamaTermino] = useState(null);

  // Câncer de Próstata
  const [cancerDeProstataAtivo, setCancerDeProstataAtivo] = useState(true);
  const [cancerDeProstataInicio, setCancerDeProstataInicio] = useState(null);
  const [cancerDeProstataTermino, setCancerDeProstataTermino] = useState(null);

  // Sepse e Choque Séptico
  const [sepseChoqueSepticoAtivo, setSepseChoqueSepticoAtivo] = useState(true);
  const [sepseChoqSepticoInicio, setSepseChoqSepticoInicio] = useState(null);
  const [sepseChoqSepticoTermino, setSepseChoqSepticoTermino] = useState(null);

  // Sindrome Coronariana Aguda - SCA
  const [sindromeCaAtivo, setSindromeCaAtivo] = useState(true);
  const [sindromeCaInicio, setSindromeCaInicio] = useState(null);
  const [sindromeCaTermino, setSindromeCaTermino] = useState(null);

  const [linhasDeCuidado, setLinhasDeCuidado] = useState([]);
  const [showErrors, setShowErrors] = useState([]);

  const [retornUserId, setRetornUserId] = useState();

  const [nomeInstituicao, setNomeInstituicao] = useState();

  const getCareLine = async () => {
    const response = await api.get('indicadores-linhas-de-cuidado', {
      headers: {
        Authorization: String(token),
      },
    });

    setLinhasDeCuidado(response.data);
  };

  const ObterDadosInstituicao = async () => {
    const res = await api.get(`instituicoes/${location.state.id}`, {
      headers: {
        Authorization: String(token),
      },
    });

    const { indicadores, nomeFantasia } = res.data;

    setNomeInstituicao(nomeFantasia);

    if (indicadores.length < 1) {
      getCareLine();
    } else {
      indicadores.forEach(
        ({ ativo, nomeIdentificador, periodoInicial, periodoFinal }) => {
          (nomeIdentificador === 'indicadores_painel_geral' &&
            (setIndicPainelGeralAtivo(ativo),
            setIndicPainelGeralInicio(periodoInicial),
            setIndicPainelGeralTermino(periodoFinal))) ||
            (nomeIdentificador === 'acidente_vascular_cerebral' &&
              (setIndicAvcAtivo(ativo),
              setIndicAvcInicio(periodoInicial),
              setIndicAvcTermino(periodoFinal))) ||
            (nomeIdentificador === 'artropatia_de_quadril' &&
              (setArtroDeQuadrilAtivo(ativo),
              setArtroDeQuadrilInicio(periodoInicial),
              setArtroDeQuadrilTermino(periodoFinal))) ||
            (nomeIdentificador === 'cancer_de_mama' &&
              (setCancerDeMamaAtivo(ativo),
              setCancerDeMamaInicio(periodoInicial),
              setCancerDeMamaTermino(periodoFinal))) ||
            (nomeIdentificador === 'cancer_de_prostata' &&
              (setCancerDeProstataAtivo(ativo),
              setCancerDeProstataInicio(periodoInicial),
              setCancerDeProstataTermino(periodoFinal))) ||
            (nomeIdentificador === 'sepse_e_choque_septico' &&
              (setSepseChoqueSepticoAtivo(ativo),
              setSepseChoqSepticoInicio(periodoInicial),
              setSepseChoqSepticoTermino(periodoFinal))) ||
            (nomeIdentificador === 'sindrome_coronariana_aguda' &&
              (setSindromeCaAtivo(ativo),
              setSindromeCaInicio(periodoInicial),
              setSindromeCaTermino(periodoFinal)));
        }
      );
    }

    setLinhasDeCuidado(indicadores);
  };

  useEffect(() => {
    ObterDadosInstituicao();

    if (location.state.userId) {
      setRetornUserId(location.state.userId);
    }
  }, []);

  const idInstituicao = location.state.id;
  async function onSubmit() {
    const itemsDates = [
      {
        name: 'indicadores_painel_geral',
        indicador: indicPainelGeralInicio,
        ativo: indicPainelGeralAtivo,
      },
      {
        name: 'acidente_vascular_cerebral',
        indicador: indicAvcInicio,
        ativo: indicAvcAtivo,
      },
      {
        name: 'artropatia_de_quadril',
        indicador: artroDeQuadrilInicio,
        ativo: artroDeQuadrilAtivo,
      },
      {
        name: 'cancer_de_mama',
        indicador: cancerDeMamaInicio,
        ativo: cancerDeMamaAtivo,
      },

      {
        name: 'cancer_de_prostata',
        indicador: cancerDeProstataInicio,
        ativo: cancerDeProstataAtivo,
      },

      {
        name: 'sepse_e_choque_septico',
        indicador: sepseChoqSepticoInicio,
        ativo: sepseChoqueSepticoAtivo,
      },

      {
        name: 'sindrome_coronariana_aguda',
        indicador: sindromeCaInicio,
        ativo: sindromeCaAtivo,
      },
    ];

    const itemsDatesErr = [];
    itemsDates.forEach(item => {
      if (!item.indicador && item.ativo) {
        itemsDatesErr.push(item.name);
      }
    });

    setShowErrors([...showErrors, ...itemsDatesErr]);

    if (itemsDatesErr.length > 0) {
      Swal.fire({
        title: `Atenção`,
        text: `Favor inserir as datas de início de coleta.`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });

      return;
    }

    const data = [
      {
        ativo: true,
        nomeIdentificador: 'indicadores_painel_geral',
        periodoInicial: !indicPainelGeralInicio ? null : indicPainelGeralInicio,
        periodoFinal: !indicPainelGeralTermino ? null : indicPainelGeralTermino,
      },
      {
        ativo: Boolean(indicAvcAtivo),
        nomeIdentificador: 'acidente_vascular_cerebral',
        periodoInicial:
          indicAvcAtivo && !indicAvcInicio ? null : indicAvcInicio,
        periodoFinal:
          indicAvcAtivo && !indicAvcTermino ? null : indicAvcTermino,
      },
      {
        ativo: Boolean(artroDeQuadrilAtivo),
        nomeIdentificador: 'artropatia_de_quadril',
        periodoInicial:
          artroDeQuadrilAtivo && !artroDeQuadrilInicio
            ? null
            : artroDeQuadrilInicio,
        periodoFinal:
          artroDeQuadrilAtivo && !artroDeQuadrilTermino
            ? null
            : artroDeQuadrilTermino,
      },
      {
        ativo: Boolean(cancerDeMamaAtivo),
        nomeIdentificador: 'cancer_de_mama',
        periodoInicial:
          cancerDeMamaAtivo && !cancerDeMamaInicio ? null : cancerDeMamaInicio,
        periodoFinal:
          cancerDeMamaAtivo && !cancerDeMamaTermino
            ? null
            : cancerDeMamaTermino,
      },
      {
        ativo: Boolean(cancerDeProstataAtivo),
        nomeIdentificador: 'cancer_de_prostata',
        periodoInicial:
          cancerDeProstataAtivo && !cancerDeProstataInicio
            ? null
            : cancerDeProstataInicio,
        periodoFinal:
          cancerDeProstataAtivo && !cancerDeProstataTermino
            ? null
            : cancerDeProstataTermino,
      },
      {
        ativo: true,
        nomeIdentificador: 'sepse_e_choque_septico',
        periodoInicial: !sepseChoqSepticoInicio ? null : sepseChoqSepticoInicio,
        periodoFinal: !sepseChoqSepticoTermino ? null : sepseChoqSepticoTermino,
      },
      {
        ativo: Boolean(sindromeCaAtivo),
        nomeIdentificador: 'sindrome_coronariana_aguda',
        periodoInicial:
          sindromeCaAtivo && !sindromeCaInicio ? null : sindromeCaInicio,
        periodoFinal:
          sindromeCaAtivo && !sindromeCaTermino ? null : sindromeCaTermino,
      },
    ];

    try {
      const response = await api.post(
        `/instituicoes/${idInstituicao}/indicadores-linha-de-cuidado`,
        data,
        {
          headers: {
            Authorization: String(token),
          },
        }
      );

      if (response.status === 201) {
        toast.success(response.data.menssagem, {
          autoClose: 5000,
        });

        setTimeout(() => {
          history.push('/administrador/instituicoes-participantes');
        }, 800);
      }
    } catch (error) {
      Swal.fire({
        title: '',
        html: `
        <div class="headerModalIndicador">
      <img src=${CancelIcon} />
      <h2><span>${error.response.data.error}</h2></div>
        <p>Verifique e tente novamente. 
        <br> <br>
        <div style="background-color: #f6c2c2; padding: 20px">
        <span style="font-size:13px;color: #cc0000">As linhas de cuidado Indicadores do Painel Geral, Sepse e Choque Séptico
        <br> são de preenchimento obritagório.  Ao ativar uma Linha de Cuidado, lembre-se de informar o período de coleta.</span>
        </div>
        </p>

        `,
        icon: '',
        confirmButtonColor: '#cc0000',
        customClass: {
          container: 'container-modal-selecao-linhadecuidado',
        },
      });
    }
  }

  const voltarCadastroGestor = () => {
    if (retornUserId) {
      history.push({
        pathname: `/administrador/editar-usuario/${retornUserId}/?cadastro-gestor=true`,
        state: {
          idInstituicao,
          userId: retornUserId,
          nomeFantasia: nomeInstituicao,
        },
      });
    } else {
      history.goBack();
    }
  };

  const setDateValue = useCallback((indicador, dateString) => {
    switch (indicador) {
      case 'indicadores_painel_geral':
        setIndicPainelGeralInicio(dateString);
        break;
      case 'acidente_vascular_cerebral':
        setIndicAvcInicio(dateString);
        break;
      case 'artropatia_de_quadril':
        setArtroDeQuadrilInicio(dateString);
        break;
      case 'cancer_de_mama':
        setCancerDeMamaInicio(dateString);
        break;
      case 'cancer_de_prostata':
        setCancerDeProstataInicio(dateString);
        break;
      case 'sepse_e_choque_septico':
        setSepseChoqSepticoInicio(dateString);
        break;
      case 'sindrome_coronariana_aguda':
        setSindromeCaInicio(dateString);
        break;
      default:
    }
  }, []);

  const normalizeDate = useCallback(periodo => {
    let periodoIn;
    if (!periodo) {
      periodoIn = '';
    } else {
      const splitDate = periodo.split('/');
      periodoIn = moment(`${splitDate[1]}-${splitDate[0]}`, 'YYYY-MM');
    }

    return periodoIn;
  }, []);

  return (
    <>
      <Breadcumbs
        path="selecao-das-linhas-de-cuidado"
        pathTitle="Seleção das Linhas de Cuidado"
      />
      <PageTitle>
        <div className="voltar">
          <button type="button" onClick={() => voltarCadastroGestor()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
        <span>Seleção das Linhas de Cuidado</span>
      </PageTitle>
      <BoxContent>
        <Container>
          <Content>
            <h3>
              Selecione abaixo as <span>linhas de cuidado</span> que a<br />
              instituição irá coletar
            </h3>

            <FormContainer>
              <form onSubmit={handleSubmit(onSubmit)}>
                {linhasDeCuidado.length > 0 &&
                  linhasDeCuidado.map(
                    ({ nomeIdentificador, periodoInicial, periodoFinal }) => {
                      const nome = nomeIndicadores[nomeIdentificador];

                      let periodoIn;
                      if (periodoInicial === 'null' || !periodoInicial) {
                        periodoIn = '';
                      } else {
                        periodoIn = String(periodoInicial).split('/');
                      }

                      let periodoFin;
                      if (periodoFinal === 'null' || !periodoFinal) {
                        periodoFin = '';
                      } else {
                        periodoFin = String(periodoFinal).split('/');
                      }

                      return (
                        <BoxForm key={nomeIdentificador}>
                          <TitleSection active={active}>
                            <SwitchButton>
                              {nomeIdentificador ===
                                'indicadores_painel_geral' ||
                              nomeIdentificador === 'sepse_e_choque_septico' ? (
                                ''
                              ) : (
                                <Switch
                                  checked={
                                    (nomeIdentificador ===
                                      'indicadores_painel_geral' &&
                                      indicPainelGeralAtivo) ||
                                    (nomeIdentificador ===
                                      'acidente_vascular_cerebral' &&
                                      indicAvcAtivo) ||
                                    (nomeIdentificador ===
                                      'artropatia_de_quadril' &&
                                      artroDeQuadrilAtivo) ||
                                    (nomeIdentificador === 'cancer_de_mama' &&
                                      cancerDeMamaAtivo) ||
                                    (nomeIdentificador ===
                                      'cancer_de_prostata' &&
                                      cancerDeProstataAtivo) ||
                                    (nomeIdentificador ===
                                      'sepse_e_choque_septico' &&
                                      sepseChoqueSepticoAtivo) ||
                                    (nomeIdentificador ===
                                      'sindrome_coronariana_aguda' &&
                                      sindromeCaAtivo)
                                  }
                                  onClick={() =>
                                    (nomeIdentificador ===
                                      'indicadores_painel_geral' &&
                                      setIndicPainelGeralAtivo(
                                        !indicPainelGeralAtivo
                                      )) ||
                                    (nomeIdentificador ===
                                      'acidente_vascular_cerebral' &&
                                      setIndicAvcAtivo(!indicAvcAtivo)) ||
                                    (nomeIdentificador ===
                                      'artropatia_de_quadril' &&
                                      setArtroDeQuadrilAtivo(
                                        !artroDeQuadrilAtivo
                                      )) ||
                                    (nomeIdentificador === 'cancer_de_mama' &&
                                      setCancerDeMamaAtivo(
                                        !cancerDeMamaAtivo
                                      )) ||
                                    (nomeIdentificador ===
                                      'cancer_de_prostata' &&
                                      setCancerDeProstataAtivo(
                                        !cancerDeProstataAtivo
                                      )) ||
                                    (nomeIdentificador ===
                                      'sepse_e_choque_septico' &&
                                      setSepseChoqueSepticoAtivo(
                                        !sepseChoqueSepticoAtivo
                                      )) ||
                                    (nomeIdentificador ===
                                      'sindrome_coronariana_aguda' &&
                                      setSindromeCaAtivo(!sindromeCaAtivo))
                                  }
                                />
                              )}
                            </SwitchButton>
                            <span>{nome || nomeIdentificador}</span>
                          </TitleSection>

                          <Row>
                            <Col>
                              <label htmlFor={`mesAno-${nomeIdentificador}`}>
                                Data de início de coleta
                              </label>

                              <MonthPicker
                                name={nomeIdentificador}
                                className={
                                  showErrors.includes(nomeIdentificador) &&
                                  'errorMonthPicker'
                                }
                                defaultValue={normalizeDate(periodoInicial)}
                                id={`mesAno-${nomeIdentificador}`}
                                format="MM/YYYY"
                                locale={locale}
                                placeholder="Mês / Ano"
                                style={{ borderBlockColor: 'red' }}
                                onChange={(value, dateString) => {
                                  setShowErrors(
                                    showErrors.filter(
                                      item => item !== nomeIdentificador
                                    )
                                  );
                                  setDateValue(nomeIdentificador, dateString);
                                }}
                              />
                              {showErrors.includes(nomeIdentificador) && (
                                <span className="errorField">
                                  Campo obrigatório
                                </span>
                              )}
                            </Col>
                          </Row>
                        </BoxForm>
                      );
                    }
                  )}

                <ButtonBox>
                  <GreenButton type="submit">
                    Salvar (Finalizar cadastro)
                  </GreenButton>
                </ButtonBox>
              </form>
            </FormContainer>
          </Content>
        </Container>
      </BoxContent>
    </>
  );
};

SelecaoDasLinhasDeCuidado.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.number.isRequired,
      userId: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default SelecaoDasLinhasDeCuidado;
